import { MenuItem, Select } from '@mui/material'

import { ChevronDownIcon } from '@/assets/icons/chevron-icons'

const iconContainerStyles = {
  '& .MuiSelect-icon': {
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#667085',
    width: '20px',
    height: '20px',
  },
  '& .MuiSelect-iconOpen': {
    transform: 'translateY(-50%) rotate(180deg)',
  },
}

export default function GradeLevelSelector({ gradeLevel, setGradeLevel }) {
  return (
    <Select
      fullWidth
      IconComponent={ChevronDownIcon}
      sx={{
        '&.MuiInputBase-root': {
          height: 44,
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '8px !important',
          border: '1px solid #D0D5DD !important',
        },
        ...iconContainerStyles,
      }}
      value={gradeLevel}
      onChange={e => setGradeLevel(e.target.value)}
    >
      {[...Array(12).keys()].map(i => (
        <MenuItem key={i} value={i + 1}>
          {i + 1}
        </MenuItem>
      ))}
      <MenuItem value="college">College</MenuItem>
    </Select>
  )
}
